"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleFormComponent = void 0;
const React = __importStar(require("react"));
const ChartShowButtonComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/ChartShowButtonComponent");
const antd_1 = require("antd");
const PeriodDaysComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/common/PeriodDaysComponent");
const LifecycleGranularityComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/form/LifecycleGranularityComponent");
const LifecyclePageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecyclePageDataProvider");
const LifecyclePageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecyclePageModelProvider");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const LifecycleFormComponent = () => {
    const lifecyclePageDataContext = (0, LifecyclePageDataProvider_1.useLifecyclePageDataContext)();
    const lifecyclePageModelContext = (0, LifecyclePageModelProvider_1.useLifecyclePageModelContext)();
    const jsonModel = lifecyclePageModelContext.pageModelStateFns.getFormJSONModel();
    const last = jsonModel.getPeriodDaysJSONModel().getLast();
    const granularity = jsonModel.getGranularityJSONModel().getGranularity();
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Form, null,
            React.createElement(PageContent_1.default.CardSection, null),
            React.createElement(antd_1.Row, { gutter: 12 },
                React.createElement(antd_1.Col, null,
                    React.createElement(PeriodDaysComponent_1.PeriodDaysComponent, { value: last, onChange: lifecyclePageModelContext.pageModelStateFns.onPeriodChanged })),
                React.createElement(antd_1.Col, null,
                    React.createElement(LifecycleGranularityComponent_1.LifecycleGranularityComponent, { value: granularity, onChange: lifecyclePageModelContext.pageModelStateFns.onGranularityChanged }))),
            React.createElement(antd_1.Row, { className: "drawButtonRow" },
                React.createElement(antd_1.Col, { span: 24 },
                    React.createElement(ChartShowButtonComponent_1.ChartShowButtonComponent, { inProgress: lifecyclePageDataContext.state.status.inProgress, onClick: lifecyclePageModelContext.pageModelStateFns.show, disabled: false })))));
};
exports.LifecycleFormComponent = LifecycleFormComponent;
